module.exports = __webpack_public_path__ + "img/29.96ebfc38.svg";